<template>
    <div class="custom-year">
        <div class="scroll-box">
            <div class="text-item">每年</div>
            <div class="scroll-month">
                <ScrollModule :items="monthArray" :selected="month" @submitEvent="saveMonth($event)"/>
            </div>
            <div class="text-item">月</div>
            <div class="scroll-day">
                <ScrollModule :items="dayArray" :selected="day" @submitEvent="saveDay($event)"/>
            </div>
            <div class="text-item">日</div>
        </div>
        <div class="skip-state">
            <div class="text-skip">智能跳过法定节假日</div>
            <div class="my-cursor"
                 :class="{
                'icon-switch-false': !skipHolidaysState,
                'icon-switch-true': skipHolidaysState,
            }" @click.stop="saveSkipState">
            </div>
        </div>
    </div>
</template>

<script>
import ScrollModule from "@/pages/List/MatterInfo/ScrollModule";
export default {
    name: "RepeatYear",
    components: {
        ScrollModule
    },
    data(){
        return {
            monthArray: [],
            dayArray: [],
            month: "1",
            day: "1",
        }
    },
    props: {
        repeatInfo: {
            type: String,
            default: "",
        },
        skipHolidaysState: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        saveMonth: function(e){
            this.month = e;
            this.submit();
        },
        saveDay: function(e){
            this.day = e;
            this.submit();
        },
        submit: function(){
            const repeatInfo = this.month + this.$Utils.addZero(this.day);
            this.$emit("submitEvent", {repeatType: 'custom_year', repeatCycle: 1, repeatInfo: repeatInfo});
        },
        saveSkipState: function(){
            this.$emit("submitSkipState", !this.skipHolidaysState);
        },
    },
    created(){
        for(let i=1; i<32; i++){
            if(i < 13){
                this.monthArray.push(i.toString());
            }
            this.dayArray.push(i.toString());
        }
    },

    mounted() {
        if(this.repeatInfo === ""){
            const today = new Date();
            this.month = (today.getMonth() + 1).toString();
            this.day = today.getDate().toString();
            this.submit();
        }else{
            const repeatInfo = this.$Utils.splitRepeatInfo(this.repeatInfo, "date");
            this.month = repeatInfo.month.toString();
            this.day = repeatInfo.day.toString();
        }
    }
}
</script>

<style scoped>
div.custom-year{
    width: 100%;
    background: rgba(254,228,148,0.2);
    border-radius: 0.15rem;
    border: 0.02rem solid #FEE494;
    padding: 0.3rem 0.2rem;
    box-sizing: border-box;
    margin-top: 0.2rem;
}
div.scroll-box{
    width: 100%;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.2rem;
}
div.text-item{
    width: 0.5rem;
    font-weight: bold;
    font-size: 0.15rem;
    color: #000000;
    text-align: center;
}
div.scroll-month, div.scroll-day{
    width: 0.5rem;
    height: 1.2rem;
    text-align: center;
}

div.skip-state{
    width: 100%;
    height: 0.36rem;
    background: rgba(252, 132, 112, 0.3);
    border-radius: 0.06rem;
    margin-top: 0.2rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    padding: 0 0.12rem;
}
div.text-skip{
    font-size: 0.15rem;
    color: #000000;
    text-align: center;
}
div.icon-switch-true, div.icon-switch-false{
    width: 0.5rem;
    height: 0.24rem;
}
div.icon-switch-true{
    background: url("../../../assets/images/List/icon-switch-true.png");
    background-size: cover;
}
div.icon-switch-false{
    background: url("../../../assets/images/List/icon-switch-false.png");
    background-size: cover;
}
</style>